export function createBasicFormatter(config) {
    const { moment } = config;
    const CURRENCY_SKIP_FRACTION_THRESHOLD = 1000;
    const formatter = {
        short: new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
        }),
        longWeekday: new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            weekday: 'short',
            year: 'numeric',
        }),
        longNoWeekday: new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        }),
    };
    function nFormatter(num) {
        if (num >= 1000000000) {
            return [
                Number((num / 1000000000).toFixed(1).replace(/\.0$/, '')),
                'G',
            ];
        }
        if (num >= 1000000) {
            return [Number((num / 1000000).toFixed(1).replace(/\.0$/, '')), 'M'];
        }
        if (num >= 1000) {
            return [Number((num / 1000).toFixed(1).replace(/\.0$/, '')), 'K'];
        }
        return [num, null];
    }
    return {
        formatPercentage(value, options) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'percent',
                maximumFractionDigits: options?.decimals ?? 2,
            });
            return formatter.format(value);
        },
        formatCurrency(value, options) {
            let suffix = null;
            if (options?.notation == 'short') {
                const [truncatedValue, truncatedSuffix] = nFormatter(value);
                suffix = truncatedSuffix;
                value = truncatedValue;
            }
            const integer = new Intl.NumberFormat('en-US', {
                style: 'currency',
                // notation: value > 1000 ? 'compact' : undefined,
                currency: 'usd',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            const fraction = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'usd',
                minimumFractionDigits: 2,
            });
            const isInteger = value % 1 == 0;
            const isLarge = value >= CURRENCY_SKIP_FRACTION_THRESHOLD;
            const formatter = isLarge || isInteger ? integer : fraction;
            const formatted = formatter.format(value);
            return [formatted, suffix].filter(Boolean).join('');
        },
        formatLongDate(value) {
            return formatter.longWeekday.format(value).replace(',', ' ');
        },
        formatShortDate(value, options) {
            // return formatter.short.format(value);
            const normal = typeof value === 'string' ? new Date(value) : value;
            const formatter = new Intl.DateTimeFormat('en-US', {
                // timeZone: options.timezone,
                day: options.granularity === 'month' ? undefined : 'numeric',
                month: options.granularity === 'month' ? 'short' : 'short',
                year: undefined,
                weekday: options.granularity === 'day' ? 'short' : undefined,
            });
            // console.log('formatting', value);
            // console.log('result', formatter.format(normal));
            return formatter.format(normal);
        },
        formatRange(start, end) {
            return formatter.longNoWeekday.formatRange(start, end);
        },
        add(value, amount, unit) {
            return moment(value).add(amount, unit).subtract(1, 'day').toDate();
        },
    };
}
//# sourceMappingURL=momentFormatProvider.js.map